module.exports = __webpack_public_path__ + "img/swipe-up.90ddd285.svg";